import { actionTypes } from '@/core/constants'
import PenalidadesUrlBuilder from '@/core/utils/factory/penalidades/PenalidadesUrlBuilder'
import PenalidadesApiClient from '@/core/apiclient/penalidades/PenalidadesApiClient'

function getApiClient(obj) {
	const urlBuilder = new PenalidadesUrlBuilder(obj.tipo)
	return new PenalidadesApiClient(urlBuilder)
}

export default {
	async [actionTypes.PENALIDADES.BUSCAR_PENALIDADES](context, objBusca) {
		const apiClient = getApiClient(objBusca)
		let { data } = await apiClient.buscaPaginada(objBusca)
		return data
	},

	async [actionTypes.PENALIDADES.VALIDAR_PENALIDADES](context, objValidar) {
		const apiClient = getApiClient(objValidar)

		let { data } = await apiClient.validarPermissaoPenalidade(objValidar)
		return data
	},

	async [actionTypes.PENALIDADES.EXCLUIR_PENALIDADE](context, objExcluir) {
		const apiClient = getApiClient(objExcluir)

		let { data } = await apiClient.excluirPenalidade(objExcluir)
		return data
	},
}
